/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  AssignAffiliateReferralOptions,
  AssignAffiliateReferralResponses,
} from '../types/AssignAffiliateReferral'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Authenticated existing users may assign a referral code once. The code must belong to their own tenant or to a global tenant, whose referrers serve every tenant. No user_id or tenant_id override is accepted. New assignments reject self-referral and require an active program. Repeating the same code returns the original assignment without changing its timestamp; changing the code returns 409. Only activity from assignment onward counts. This does not change signup_source.
 * @summary Assign your affiliate referrer
 * {@link /v1/affiliate_referrals/self}
 */
export function assignAffiliateReferral<ThrowOnError extends boolean = true>(
  options: Options<AssignAffiliateReferralOptions, ThrowOnError>,
): Unwrappable<RequestResult<AssignAffiliateReferralResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/v1/affiliate_referrals/self',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<AssignAffiliateReferralResponses, ThrowOnError>>,
  )
}
